import * as Sentry from "@sentry/react";

export const initSentry = () => {
  // Only track production errors
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  Sentry.init({
    dsn:
      "https://c7ae6679ff6a4d409e254bec72647e98@o307548.ingest.sentry.io/5546945",
    environment: "frontend",
  });
};
